import React from 'react';

const Filters = ({ id, filter, activeFilter, setActiveFilter }) => {

    return <div
        className={`filter${filter.id === activeFilter.id ? ' active' : ''}`}
        onClick={() => setActiveFilter(filter)}
    >
        {filter.name}
    </div>
}

export default Filters;